import * as React from 'react';
import ModalContext from '../Modal/ModalContext';
const ModalContextProvider = ({ children }) => {
    const [currentModalZIndex, setCurrentModalZIndex] = React.useState(100);
    const value = { currentModalZIndex, setCurrentModalZIndex };
    return (React.createElement(ModalContext.Provider, { value: value }, children));
};
export default ModalContextProvider;
